<form #clientJobForm="ngForm" (ngSubmit)="container.scrollTop = 0; addJobdetails(clientJobForm)" class="" novalidate>
  <div class="col-sm-12 p-0">
    <div class="addJob-modal-content addClientanimate">
      <div class="bg-white br-15px">
        <div class="cmn-modal-header">
          <h4 class="modal-header-title">
            <span *ngIf="currentScreenActive == 1">
              Step ({{currentScreenActive}}/{{lastTab}}): {{isEditMode ? 'Update job' : 'Create job'}}
            </span>
            <span *ngIf="currentScreenActive == 2">
              Step ({{currentScreenActive}}/{{lastTab}}): Assign & Estimate
            </span>
            <span *ngIf="currentScreenActive == 3">
              Step ({{currentScreenActive}}/{{lastTab}}):  {{ recurrenceEnableChk ? 'Recurrence' : 'Frequency' }}
            </span>
          </h4>
        </div>
        <div class="cmn-modal-content" #container>
          <!-- stepper -->
          <div class="createjob-top-stepper" *ngIf="false">
            <div class="createjob-top-stepper-row" [ngClass]="recurrenceFeatureFlag ? '': 'no_recurrence_tab'">
              <div class="createjob-top-stepper-row-item"
                [ngClass]="{'active-stepper-item' : currentScreenActive == 1}">
                <div class="createjob-top-stepper-row-item-circle">
                  <img alt="icon" src="../../../../assets/img/list-bullet-dark.svg" *ngIf="currentScreenActive != 1" />
                  <img alt="icon" src="../../../../assets/img/list-bullet-white.svg" *ngIf="currentScreenActive == 1" />
                </div>
                <h5 class="createjob-top-stepper-row-item-title">
                  Job
                </h5>
              </div>
              <div class="createjob-top-stepper-row-item"
                [ngClass]="{'active-stepper-item' : currentScreenActive == 2}">
                <div class="createjob-top-stepper-row-item-circle">
                  <img alt="icon" src="../../../../assets/img/assignee-dark.svg" *ngIf="currentScreenActive != 2" />
                  <img alt="icon" src="../../../../assets/img/assignee-white.svg" *ngIf="currentScreenActive == 2" />
                </div>
                <h5 class="createjob-top-stepper-row-item-title">
                  Assign & Estimate
                </h5>
              </div>
              <div class="createjob-top-stepper-row-item" *ngIf="recurrenceFeatureFlag"
                [ngClass]="{'active-stepper-item' : currentScreenActive == 3}">
                <div class="createjob-top-stepper-row-item-circle">
                  <img alt="icon" src="../../../../assets/img/recurrence-ic.svg" *ngIf="currentScreenActive != 3" />
                  <img alt="icon" src="../../../../assets/img/recurrence-ic-white.svg" *ngIf="currentScreenActive == 3" />
                </div>
                <h5 class="createjob-top-stepper-row-item-title">
                  Recurrence
                </h5>
              </div>
            </div>
          </div>
          <!-- stepper end -->
          <!-- stepper code parent div -->
          <div class="createjob-stepper-content">
            <!-- screen 1 code -->
            <div>
            <div *ngIf="currentScreenActive == 1">
              <!-- standard fields content -->
              <h5 class="fields-type-title">Standard fields</h5>
              <div class="cmn-createjob-Popup-Ui-row">
                <!-- left col content -->
                <div class="cmn-createjob-Popup-Ui-row-col">
                  <div class="form-group" *ngIf="HideQuickjob">
                    <div class="row align-items-center">
                      <h6 class="cmn-form-label mb-0 text-left col-5 padding-kc-cmd-add-job">
                        <span *ngIf="showclientjob" class="">
                          Client Code/Client Name <span class="kc-form-label client_eh">{{clientCode}} -
                            {{clientName}}</span>
                        </span>
                        <span class="">Client<b class="color_job_css">*</b></span>
                      </h6>
                      <div class="col-7 pr-1">
                        <div class="form-select-container">
                          <ng-select [items]="clientCombo" class="cmn-ngselect wthout-ellipsis-option"  data-testid="drpdwn-client-job-type"
                            bindLabel="clientName" bindValue="clientId" [clearable]="false" [disabled]="isEditMode"
                            id="client" name="clientJob" #clientJob="ngModel" required placeholder="Select client"
                            (change)="eventChangeInClient($event)" [(ngModel)]="jobDataModal.clientId"
                            (ngModelChange)="onFormChange(); onClientChange()" [virtualScroll]="true"
                            [searchFn]="onFiltering">
                            <ng-template ng-option-tmp let-item="item" let-index="index">
                              <span class="">{{item.clientName}} ({{item.clientCode}})</span>
                            </ng-template>
                            <ng-template ng-label-tmp let-selected="item">
                              <span>{{selected.clientName}} ({{selected.clientCode}})</span>
                            </ng-template>
                          </ng-select>
                          <div *ngIf="clientJobForm.submitted && clientJob.invalid && checkvalidation"
                            class="invalid-feedback invalid invalid-ejs invalid-error-cmd">
                            <div *ngIf="clientJob.errors.required">
                              Client is required
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" *ngIf="isEditMode">
                    <div class="row align-items-center">
                      <h6 class="cmn-form-label mb-0 text-left col-5 padding-kc-cmd-add-job">
                        Job code
                      </h6>
                      <h6 class="cmn-form-label mb-0 text-left col-7">
                        {{jobDataModal.jobCode}}
                      </h6>
                    </div>
                  </div>
                  <div class="form-group form-group-sm">
                    <div class="custom-row align-items-center">
                      <h6 class="cmn-form-label text-left mb-0 col-5 padding-kc-cmd-add-job-template">
                        Job type<b class="color_job_css">*</b>
                      </h6>
                      <div class="col-7 pr-0">
                        <div class="form-select-container">
                          <ng-select [items]="jobTypesL" class="cmn-ngselect wthout-ellipsis-option"
                            bindLabel="jobTypeName" bindValue="jobTypeId" (ngModelChange)="onFormChange()"
                            [clearable]="false" [disabled]="isEditMode" id="country" name="jTypeJob" #jTypeJob="ngModel"
                            required placeholder="Select job type" (ngModelChange)="eventChangeInJobType($event)"
                            [(ngModel)]="jobDataModal.jobTypeId">
                            <ng-template ng-option-tmp let-item="item" let-index="index">
                              <span class=""> {{item.jobTypeName}}</span>
                            </ng-template>
                          </ng-select>
                          <div *ngIf="jTypeJob.invalid && clientJobForm.submitted && checkvalidation"
                            class="invalid-feedback invalid invalid-ejs invalid-error-cmd">
                            <div *ngIf="jTypeJob.errors?.['required']">
                              Job type is required
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-group-sm">
                    <div class="custom-row align-items-center">
                      <h6 class="cmn-form-label text-left mb-0 col-5 padding-kc-cmd-add-job-template">Job category<b
                          class="color_job_css">*</b></h6>
                      <div class="col-7 pr-0">
                        <div class="form-multiselect-container">

                          <ng-multiselect-dropdown class="cmn-multiselect-dropdown ellipsis-hide-cmd"
                          data-testid="drpdwn-client-job-category"
                            [placeholder]="'Select job category'" name="jobCategory"
                            [settings]="jobCategorydropdownSettings" [data]="jobCategorydropdownList"
                            [(ngModel)]="jobCategoryselectedItems" (ngModelChange)="onJobCategoryChange()"
                            (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)" #jobCategory="ngModel"
                            required>
                          </ng-multiselect-dropdown>
                          <div *ngIf="jobCategory.invalid && clientJobForm.submitted && checkvalidation"
                            class="invalid-feedback invalid invalid-ejs invalid-error-cmd">
                            <div *ngIf="jobCategory.errors?.['required']">
                              Job category is required
                            </div>
                          </div>

                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                          <div class="row align-items-center">
                              <h6 class="cmn-form-label mb-0 text-left col-5 padding-kc-cmd-add-job">
                                  Job<b class="color_job_css">*</b>
                              </h6>
                              <div class="col-7 pr-1">
                                  <div class="form-input-container">
                                      <input type="text" class="form-control" placeholder="Enter job name" name="namejob"
                                      data-testid="input-client-job-name"
                                             #namejob="ngModel" [(ngModel)]="jobDataModal.jobName"
                                             (ngModelChange)="onFormChange();"
                                             [ngClass]="{'is-invalid':clientJobForm.submitted && checkvalidation && namejob.invalid}"
                                             required />
                                      <div *ngIf="namejob.invalid && clientJobForm.submitted && checkvalidation"
                                           class="invalid-feedback invalid invalid-error-cmd">
                                          <div *ngIf="namejob.errors?.['required']">
                                              Job name is required
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="form-group form-group-sm">
                          <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-5 padding-kc-cmd-add-job-template">
                                  Job
                                  template
                              </h6>
                              <div class="col-7 pr-0">
                                  <div class="form-select-container">
                                      <ng-select [items]="jobTemplate" class="cmn-ngselect wthout-ellipsis-option" data-testid="drpdwn-client-job-template"
                                                 bindLabel="templateName" bindValue="templateId" #TemplateDropdown
                                                 (clear)="onTemplateClear()" (change)="onTemplateChange()" (ngModelChange)="onFormChange()"
                                                 [clearable]="true" [disabled]="isEditMode" name="Template" #Template="ngModel"
                                                 placeholder="Select job template" [(ngModel)]="jobDataModal.templateId">
                                          <ng-template ng-option-tmp let-item="item" let-index="index">
                                              <span class=""> {{item.templateName}}</span>
                                          </ng-template>
                                      </ng-select>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="form-group form-group-sm">
                          <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-5 padding-kc-cmd-add-job-template">Estimate type</h6>
                              <div class="col-7">
                                  <div class="form-radio-inline createjobestimatetype-radio"
                                       [ngClass]="{'isDisableRadioBtn':jobDataModal.templateId || isEditMode}">
                                      <fieldset [disabled]="jobDataModal.templateId || isEditMode">
                                          <div class="fncy-radio-button form-check-inline">
                                              <input id="estimateByJob" type="radio" name="jobEstimateType" value="Job" data-testid="radio-client-job-estimate-type-job"
                                                     [(ngModel)]="jobDataModal.jobEstimateType" (change)="onChangeEstimateType()" />
                                              <label class="radio-btn-label" for="estimateByJob">Job</label>
                                          </div>
                                          <div class="fncy-radio-button form-check-inline">
                                              <input id="estimateByTask" type="radio" name="jobEstimateType" value="Task" data-testid="radio-client-job-estimate-type-task"
                                                     [(ngModel)]="jobDataModal.jobEstimateType" (change)="onChangeEstimateType()" />
                                              <label class="radio-btn-label" for="estimateByTask">Task</label>
                                          </div>
                                      </fieldset>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="form-group form-group-sm" *ngIf="recurrenceFeatureFlag">
                          <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-5 padding-kc-cmd-add-job-template">
                                  Job recurrence
                              </h6>
                              <div class="col-7">
                                  <div class="form-radio-inline createjobestimatetype-radio"
                                       [ngClass]="{'isDisableRadioBtn':jobDataModal.templateId || isEditMode}">
                                      <fieldset [disabled]="isEditMode">
                                          <div class="cmn-slide-toggle-container">
                                              <mat-slide-toggle class="fn_sz" name="prospect" color="primary" data-testid="slide-toggle-client-job-recurrence"
                                                                (click)="setRecurrenceFlag()" [(ngModel)]="recurrenceEnableChk"></mat-slide-toggle>
                                          </div>
                                      </fieldset>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="form-group form-group-sm">
                          <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-5 padding-kc-cmd-add-job-template">
                                  Financial year<b class="color_job_css">*</b>
                              </h6>
                              <div class="col-7 pr-0">
                                  <div class="form-select-container">
                                      <ng-select [items]="fyForSelection" class="cmn-ngselect" bindLabel="text" bindValue="value"
                                                 (change)="setRecurranceYear()" (ngModelChange)="onFormChange()" [clearable]="false" data-testid="drpdwn-client-job-financial-year" 
                                                 [disabled]="isEditMode" name="fyJob" #FinancialTemplate="ngModel" required
                                                 placeholder="Select financial year" [(ngModel)]="jobDataModal.financialYear"
                                                 [ngClass]="{'is-invalid':clientJobForm.submitted && checkvalidation && FinancialTemplate.invalid}">
                                          <ng-template ng-option-tmp let-item="item" let-index="index">
                                              <span class="">
                                                  {{
item.text.length > 15 ? (item.text| slice:0:15) +
                                '..' : item.text
                                                  }}
                                              </span>
                                          </ng-template>
                                      </ng-select>
                                      <div *ngIf="FinancialTemplate.invalid && clientJobForm.submitted && checkvalidation"
                                           class="invalid-feedback invalid invalid-error-cmd">
                                          <div *ngIf="FinancialTemplate.errors?.['required']">
                                              Financial year is required
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <!-- new control added CUST-3764 -->
                      <div *ngIf="!recurrenceEnableChk" class="form-group form-group-sm" >
                          <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-5 padding-kc-cmd-add-job-template">
                                  Frequency
                              </h6>
                              <div class="col-7">
                                  <div class="form-radio-inline">
                                      <div class="fncy-radio-button form-check-inline">
                                          <input type="radio" value="None" name="JobFrequencyRadio"
                                                 data-testid="input-client-job-frequency-none"
                                                 (change)='setRecurranceFrequency()' [(ngModel)]="jobselectedFrequency"
                                                 [disabled]="isEditMode" />
                                          <label class="radio-btn-label">None</label>
                                      </div>
                                      <div class="fncy-radio-button form-check-inline">
                                          <input type="radio" name="JobFrequencyRadio" value="Monthly"
                                                  data-testid="input-client-job-frequency-monthly"
                                                 (change)='setRecurranceFrequency()' [(ngModel)]="jobselectedFrequency"
                                                 [disabled]="isEditMode" />
                                          <label class="radio-btn-label">Monthly</label>
                                      </div>
                                      <div class="fncy-radio-button form-check-inline">
                                          <input type="radio" value="Quarterly" name="JobFrequencyRadio"
                                                  data-testid="input-client-job-frequency-quarterly"
                                                 (change)='setRecurranceFrequency()' [(ngModel)]="jobselectedFrequency"
                                                 [disabled]="isEditMode" />
                                          <label class="radio-btn-label">Quarterly</label>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div *ngIf="!recurrenceEnableChk" class="form-group">
                          <div class="custom-row align-items-center" *ngIf="jobselectedFrequency === 'Monthly' ||  jobselectedFrequency === 'Quarterly' ">
                              <h6 class="cmn-form-label text-left mb-0 col-5 padding-kc-cmd-add-job-template">
                                  Period <b class="color_job_css">*</b>
                              </h6>
                              <div class="col-7">
                                  <!-- monthly dropdown -->
                                  <div class="form-multiselect-container w-260" *ngIf="jobselectedFrequency === 'Monthly'">
                                      <ng-multiselect-dropdown class="cmn-multiselect-dropdown flt-dropdown ellipsis-itemname"
                                                              data-testid="drpdwn-client-job-period-monthly"
                                                               [placeholder]="'Select period'" name="statusMonthly" #statusMonthly="ngModel"
                                                               [(ngModel)]="statusMonthlyModel" (ngModelChange)='setRecurrancePeriod()'
                                                               [settings]="frequencyConfig" [disabled]="isEditMode" [data]="frequencyMonthList"  [required]="jobselectedFrequency === 'Monthly'">
                                      </ng-multiselect-dropdown>
                                  </div>
                                  <!-- monthly dropdown end-->
                                  <!-- quarterly-->
                                  <div class="form-multiselect-container w-260" *ngIf="jobselectedFrequency === 'Quarterly'">
                                      <ng-multiselect-dropdown class="cmn-multiselect-dropdown flt-dropdown ellipsis-itemname"
                                                              data-testid="drpdwn-client-job-period-quarterly"
                                                               [placeholder]="'Select period'" name="statusQuarterly" #statusQuarterly="ngModel"
                                                               [(ngModel)]="statusQuarterlyModel" (ngModelChange)='setRecurrancePeriod()'
                                                               [settings]="frequencyQuarterConfig" [disabled]="isEditMode" [data]="frequencyQuarterList"  [required]="jobselectedFrequency === 'Quarterly'">
                                      </ng-multiselect-dropdown>
                                  </div>
                                  <!-- quarterly end-->
                              </div>
                          </div>
                      </div>
                      <div class="form-group form-group-sm">
                          <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-5 padding-kc-cmd-add-job-template">
                                  Status
                              </h6>
                              <div class="col-7 pr-0">
                                  <div class="createjob-status-dropdown form-select-container">
                                      <div class="dropdown-wrapper" dropdown>
                                          <a class="dropdown-action" dropdownToggle data-bs-toggle="dropdown"
                                          data-testid="drpdwn-client-job-status"
                                             [ngClass]="{'selected': selectedStatus != 'Select status'}">
                                              {{getSelectedStatus()}}
                                              <span class="chevron-icon">
                                              </span>
                                          </a>
                                          <ul class="dropdown-menu" *dropdownMenu>
                                              <li *ngFor="let status of statuslist">
                                                  <div class="status-wrapper">
                                                      <div class="cmn-status-indcator-container">
                                                          <i class="fa fa-square" [ngClass]="{'Not-Started': status.name == 'Not-Started',
                                                  'In-Progress': status.name == 'In-Progress' ||  status.name == 'Review',
                                                  'On-Hold': status.name == 'On Hold',
                                                  'Completed': status.name == 'Completed'}"></i>
                                    <span class="createjob-status-name">{{status.name}}</span>
                                  </div>
                                  <div class="createjob-substatus">
                                    <ul class="p-0 m-0">
                                      <li *ngFor="let subStatus of status.data"
                                        (click)="selectedStatus = subStatus.statusName; onSelectStatus(subStatus)" data-testid="drpdwn-client-job-status-substatus">
                                        {{subStatus.statusName}}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-group-sm">
                    <div class="custom-row align-items-center">
                      <h6 class="cmn-form-label text-left mb-0 col-5 padding-kc-cmd-add-job-template">
                        Priority
                      </h6>
                      <div class="col-7">
                        <div class="form-select-container w-260">
                          <ng-select [items]="jobPriorityList" class="cmn-ngselect" [clearable]="false"
                            bindLabel="jobPriorityName" bindValue="jobPriorityId" placeholder="Select priority"
                            [(ngModel)]="jobDataModal.priority" data-testid="drpdwn-client-job-priority">
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-group-sm description-textarea">
                    <div class="row">
                      <h6 class="cmn-form-label mb-0 text-left col-5 pt-1 padding-kc-cmd-add-job">
                        Description
                      </h6>
                      <div class="col-7 pr-1">
                        <div class="form-textarea-container">
                          <textarea type="text" rows="5" class="form-control" placeholder="Enter description"
                            name="scopejob" #scopejob="ngModel" data-testid="input-client-job-description"
                            (ngModelChange)="onFormChange();descriptionLabelChange($event);"
                            [(ngModel)]="jobDataModal.scope" (keyup)="countdiscreption($event.target.value)"
                            maxlength="1000"
                            [ngClass]="{ 'is-invalid':clientJobForm.submitted && scopejob.invalid }"></textarea>
                          <div class="text-right">{{maxLength}}/1000</div>
                          <div *ngIf="checkerrordescription" class="invalid-feedback invalid">
                            <div>
                              Character limit exceeded (1000 character)
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- left col content end -->
                <!-- right col content -->
                <div class="cmn-createjob-Popup-Ui-row-col">
                  <div class="form-group form-group-sm">
                    <div class="custom-row align-items-center">
                      <h6 class="cmn-form-label text-left mb-0 col-5 padding-kc-cmd-add-job-template">
                        Division<b class="color_job_css">*</b>
                      </h6>
                      <div class="col-7">
                        <div class="form-select-container w-260">
                          <ng-select [items]="divisions" class="cmn-ngselect wthout-ellipsis-option"          data-testid="drpdwn-client-job-division"
                                     bindLabel="divisionName" bindValue="divisionId" (ngModelChange)="onFormChange()"
                                     [clearable]="false" name="divisionJob" [disabled]="isEditMode" #divisionJob="ngModel"
                                     [ngClass]="{ 'is-invalid':clientJobForm.submitted && checkvalidation && divisionJob.invalid}"
                                     required [(ngModel)]="jobDataModal.divisionId" placeholder="Select division">
                            <ng-template ng-option-tmp let-item="item" let-index="index">
                              <span class=""> {{item.divisionName}}</span>
                            </ng-template>
                          </ng-select>
                          <div *ngIf="divisionJob.invalid && clientJobForm.submitted && checkvalidation">
                            <div class="invalid-feedback invalid invalid-error-cmd">
                              <div *ngIf="divisionJob.errors?.['required']">
                                Division is required
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-group-sm" *ngIf="officeData?.canViewOffice">
                    <div class="custom-row align-items-center">
                      <h6 class="cmn-form-label text-left mb-0 col-5 padding-kc-cmd-add-job-template">
                        Office
                      </h6>
                      <div class="col-7">
                        <div class="form-select-container w-260">
                          <ng-select [items]="officeData.officeList" class="cmn-ngselect wthout-ellipsis-option"
                                     bindLabel="name" bindValue="officeId" (ngModelChange)="onFormChange()" [clearable]="true"
                                     name="officeJob" #officeJob="ngModel" [(ngModel)]="officeData.selectedOfficeId"
                                     (clear)="clearOffice()" placeholder="Select office" data-testid="drpdwn-client-job-office">
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-group-sm">
                    <div class="custom-row align-items-center">
                      <h6 class="cmn-form-label text-left mb-0 col-5 padding-kc-cmd-add-job-template">
                        Debtor client<b class="color_job_css">*</b>
                      </h6>
                      <div class="col-7">
                        <div class="form-select-container w-260">
                          <ng-select [items]="debtorClientList" class="cmn-ngselect wthout-ellipsis-option"
                                     bindLabel="clientName" bindValue="debtorClientId" (ngModelChange)="onFormChange()"
                                     [clearable]="false" name="debtorClientSection"
                                     [disabled]="(savedJobData?.isDebtorEditable == false)" #debtorClientSection="ngModel"
                                     [ngClass]="{ 'is-invalid':clientJobForm.submitted && checkvalidation && debtorClientSection.invalid}"
                                     required [(ngModel)]="jobDataModal.debtorClientId" placeholder="Select debtor client" data-testid="drpdwn-client-job-debtor-client">
                            <ng-template ng-option-tmp let-item="item" let-index="index">
                              <span class=""> {{item.clientName}}</span>
                            </ng-template>
                          </ng-select>
                          <div *ngIf="debtorClientSection.invalid && clientJobForm.submitted && checkvalidation">
                            <div class="invalid-feedback invalid invalid-error-cmd">
                              <div *ngIf="debtorClientSection.errors?.['required']">
                                Debtor client is required
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-group-sm">
                    <div class="custom-row align-items-center">
                      <h6 class="cmn-form-label text-left mb-0 col-5 padding-kc-cmd-add-job-template">
                        Team
                      </h6>
                      <div class="col-7">
                        <div class="form-select-container w-260">
                          <ng-select [items]="teamList" [disabled]="!isModifyTeamData" class="cmn-ngselect"
                                     [clearable]="true" bindLabel="name" name="teamJob" #teamJob="ngModel" bindValue="teamId"
                                     [(ngModel)]="jobDataModal.teamId" placeholder="Select team" data-testid="drpdwn-client-job-team">
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-group-sm">
                    <div class="custom-row align-items-center">
                      <h6 class="cmn-form-label text-left mb-0 col-5 padding-kc-cmd-add-job-template">
                        Job partner<b class="color_job_css">*</b>
                      </h6>
                      <div class="col-7">
                        <div class="form-select-container w-260">
                          <ng-select [items]="validPartnersList"
                                     class="cmn-ngselect wthout-ellipsis-option" bindLabel="fullName" bindValue="userId"
                                     (ngModelChange)="onFormChange()" [clearable]="false" name="partnerJob" #partnerJob="ngModel"
                                     (change)="AddPartner($event); onChangeJobLevelUser($event, 'Partner')"
                                     [ngClass]="{ 'is-invalid':clientJobForm.submitted && checkvalidation && partnerJob.invalid}"
                                     required [(ngModel)]="jobDataModal.partnerId" placeholder="Select partner"  data-testid="drpdwn-client-job-partner">
                            <ng-template ng-option-tmp let-item="item" let-index="index">
                              <span class=""> {{item.fullName}}</span>
                            </ng-template>
                          </ng-select>
                          <div *ngIf="partnerJob.invalid && clientJobForm.submitted && checkvalidation"
                               class="invalid-feedback invalid invalid-error-cmd">
                            <div *ngIf="partnerJob.errors?.['required']">
                              Partner is required
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-group-sm">
                    <div class="custom-row align-items-center">
                      <h6 class="cmn-form-label text-left mb-0 col-5 padding-kc-cmd-add-job-template">
                        Job manager
                      </h6>
                      <div class="col-7">
                        <div class="form-select-container w-260">
                          <ng-select [items]="validManagersList"
                                     class="cmn-ngselect wthout-ellipsis-option" bindLabel="fullName" bindValue="userId"
                                     (ngModelChange)="onFormChange()" [clearable]="true" name="mgrJob" #mgrJob="ngModel"
                                     (change)="AddManager($event); onChangeJobLevelUser($event, 'Manager')"
                                     placeholder="Select manager" [(ngModel)]="jobDataModal.managerId"  data-testid="drpdwn-client-job-manager">
                            <ng-template ng-option-tmp let-item="item" let-index="index">
                              <span class=""> {{item.fullName}}</span>
                            </ng-template>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-group-sm">
                    <div class="custom-row align-items-center">
                      <h6 class="cmn-form-label text-left mb-0 col-5 padding-kc-cmd-add-job-template">
                        Status owner
                      </h6>
                      <div class="col-7">
                        <div class="form-select-container w-260">
                          <ng-select id="statusOwnername"
                                     name="ownername"
                                     class="cmn-ngselect jobprofile-ownr-drp owner-status-dropdown"
                                     [items]="validOwnerData"
                                     bindLabel="ownername"
                                     bindValue="Id"                                     
                                     [clearable]="false"
                                     [(ngModel)]="jobDataModal.statusOwnerId"
                                     (change)="eventChangeOwner($event)" 
                                     data-testid="drpdwn-client-job-status-owner">

                            <!--Dropdown option-->
                            <ng-template ng-option-tmp let-item="item">
                              <span>{{ item.ownername }}</span>
                            </ng-template>

                            <!--Selected value with tooltip-->
                            <ng-template ng-label-tmp let-item="item">
                              <span class="ellipsis-owner-value"
                                    matTooltip="{{ item?.ownername }}"
                                    matTooltipClass="cmn-tooltip-template">
                                {{ item?.ownername || 'Unassigned' }}
                              </span>
                            </ng-template>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-group-sm">
                    <div class="custom-row align-items-center">
                      <h6 class="cmn-form-label text-left mb-0 col-5 padding-kc-cmd-add-job-template">
                        Turn around
                      </h6>
                      <div class="col-7">
                        <div class="form-input-container w-260">
                          <input type="number" class="form-control" name="turnaround" data-testid="input-client-job-turnaround"
                                 [(ngModel)]="jobDataModal.turnaround" (ngModelChange)="onTurnaroundChange($event)"
                                 placeholder="Turnaround no of days" [disabled]="true">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="isEditMode ? true  : (jobselectedFrequency !== 'Monthly' && jobselectedFrequency !== 'Quarterly') && !recurrenceEnableChk" class="form-group">
                    <div class="row align-items-center">
                      <h6 class="cmn-form-label mb-0 text-left col-5 padding-kc-cmd-add-job">
                        Start date<b class="color_job_css">*</b>
                      </h6>
                      <div class="col-7">
                        <div class="form-datepicker-container w-260 cmn-material-datepicker">
                          <mat-form-field floatLabel="never" appearance="standard">
                            <input class="cmn-mat-dtpicker-input" matInput #startDateJ1="ngModel"
                                   (dateChange)="calculateDueDateFromStartAndTurnaround()"
                                   [(ngModel)]="jobDataModal.startDate" (ngModelChange)="onFormChange()"
                                   [matDatepicker]="startDateDatepicker" name="startDateJ1" autocomplete="off"
                                   placeholder="dd/mm/yyyy" data-testid="input-client-job-start-date" required>
                            <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix
                                                   [for]="startDateDatepicker"></mat-datepicker-toggle>
                            <mat-datepicker panelClass="cmn-datepicker-ui" #startDateDatepicker (opened)="appendTodayButton()" (closed)="removeTodayButton()"></mat-datepicker>
                            <mat-error class="cmn-material-datepicker-errormsg">
                              Please enter the date in dd/mm/yyyy
                            </mat-error>
                          </mat-form-field>
                          <div id="startDateTodayWrapper">
                            <div id="startDateTodayAction" class="cmn-mat-dtpicker-footer d-none">
                              <button mat-button type="button" class="cmn-datepicker-today-btn cmn-blue-btn" (click)="setStartDateAsToday(startDateDatepicker)" data-testid="btn-client-job-start-date-today">
                                Today
                              </button>
                            </div>
                          </div>
                          <!-- commented due to datepicker control change -->
                          <!-- <div class="" [ngClass]="{ 'is-invalidDatePicker':clientJobForm.submitted && startDateJ1.invalid }">
          <ejs-datepicker cssClass='date_css customCSS e-selected'
                          format='dd/MM/yyyy' placeholder='Select date'
                          name="startDateJ1" #startDateJ1="ngModel"
                          (ngModelChange)="onStartDateChange($event)"
                          [(ngModel)]="jobDataModal.startDate"
                          openOnFocus='true' strictMode='true'
                          required></ejs-datepicker>

          </div>
          <div *ngIf="clientJobForm.submitted && startDateJ1.invalid" class="invalid-feedback invalid invalid-error-cmd">
          <div *ngIf="startDateJ1.errors.required">
            Start date is required
          </div>
          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="isEditMode ? true  : (jobselectedFrequency !== 'Monthly' && jobselectedFrequency !== 'Quarterly') && !recurrenceEnableChk" class="form-group">
                    <div class="row align-items-center">
                      <h6 class="cmn-form-label mb-0 text-left col-5 padding-kc-cmd-add-job">
                        Due date<b class="color_job_css">*</b>
                      </h6>
                      <div class="col-7">
                        <div class="form-datepicker-container w-260 cmn-material-datepicker">
                          <mat-form-field floatLabel="never" appearance="standard">
                            <input class="cmn-mat-dtpicker-input" matInput [min]="jobDataModal.startDate"
                                   #endDate="ngModel" [(ngModel)]="jobDataModal.dueDate" (ngModelChange)="onFormChange()"
                                   [matDatepicker]="dueDateDatepicker" name="endDate" autocomplete="off"
                                   placeholder="dd/mm/yyyy"  data-testid="input-client-job-due-date" required>
                            <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix
                                                   [for]="dueDateDatepicker"></mat-datepicker-toggle>
                            <mat-datepicker panelClass="cmn-datepicker-ui" #dueDateDatepicker></mat-datepicker>
                            <mat-error class="cmn-material-datepicker-errormsg"
                                       *ngIf="!endDate.hasError('matDatepickerMin')">
                              Please enter the date in dd/mm/yyyy
                            </mat-error>
                            <mat-error class="cmn-material-datepicker-errormsg"
                                       *ngIf="endDate.hasError('matDatepickerMin')">
                              Please enter a valid Due Date
                            </mat-error>
                          </mat-form-field>
                          <!-- commented due to datepicker control change -->
                          <!-- <div class="" [ngClass]="{ 'is-invalidDatePicker':clientJobForm.submitted && endDate.invalid }">
          <ejs-datepicker cssClass='date_css customCSS e-selected'
                          format='dd/MM/yyyy' placeholder='Select date'
                          name="endDate" #endDate="ngModel"
                          [(ngModel)]="jobDataModal.dueDate"
                          openOnFocus='true' strictMode='true'
                          required [min]="jobDataModal.startDate" (keydown)="StopDueDate($event)"></ejs-datepicker>

          </div>
          <div *ngIf="clientJobForm.submitted && endDate.invalid" class="invalid-feedback invalid invalid-error-cmd">
            <div *ngIf="endDate.errors.required">
              Due Date is required
            </div>
          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="bottom_Line_save_one mb-3"></div>
                  <div class="form-group">
                    <div class="row align-items-center">
                      <h6 class="cmn-form-label mb-0 text-left col-5 padding-kc-cmd-add-job">
                        Billing method
                      </h6>
                      <div class="col-7">
                        <div class="form-radio-inline">
                          <div class="fncy-radio-button form-check-inline">
                            <input type="radio" name="radio" [checked]="!isFixedJob" (click)="OnCheckNonFixedBilling()"
                                   class=""  data-testid="input-client-job-due-date"/>
                            <label class="radio-btn-label">Time-cost</label>
                          </div>
                          <div class="fncy-radio-button form-check-inline">
                            <input type="radio" name="radio" [checked]="isFixedJob" (click)="OnCheckFixedBilling()"
                                   class="" data-testid="radio-client-job-billing-fixed" />
                            <label class="radio-btn-label">Fixed</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row align-items-center">
                      <h6 class="cmn-form-label mb-0 text-left col-5 padding-kc-cmd-add-job">
                        Quote
                      </h6>
                      <div class="col-7">
                        <div class="form-input-container input-wth-prefix w-260">
                          <input type="text" (keypress)="DecimalCheck($event)" name="quoteJob" #quoteJob="ngModel"
                                 autocomplete="off" [(ngModel)]="jobDataModal.quote" (ngModelChange)="onFormChange()"
                                 (change)="CheckQoute(jobDataModal.quote)" placeholder="Enter amount" class="form-control" data-testid="input-client-job-quote" />
                          <img class="img-responsive" src="../../../../assets/img/billing/dollersvgIcon.svg">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                  <!-- right col content end -->
              <!-- standard fields content end-->
              <!-- custom fields content -->
              <div class="bottom_Line_save_one mb-3"></div>
              <h5 class="fields-type-title">Custom fields</h5>
              <div class="cmn-createjob-Popup-Ui-row-customfields">
                <div class="customs_fields_section"
                  [ngClass]="cf.fieldType !== 'Header'? 'customfields-colmns':'customfields-colmns-group'"
                  *ngFor="let cf of cfqjobitem; let i = index;">
                  <div *ngIf="cf.fieldType=='Header' && i == 0">
                    <span class="custom-fields-groupheader">{{cf.fieldLabel}}</span>
                    <span class="client_custom_field_css ml-2">Custom Fields</span>
                  </div>
                  <div *ngIf="cf.fieldType=='Header' && i != 0">
                    <span class="custom-fields-groupheader">{{cf.fieldLabel}}</span>
                  </div>
                  <div class="form-group" [ngClass]="cf.fieldType=='Checkbox'?'chbox-rowgroup':''">
                    <div class="row align-items-center" [ngClass]="cf.fieldType=='Checkbox'?'chbox-label':''">
                      <h6 class="cmn-form-label mb-0 text-left col-5 padding-kc-cmd-add-job"
                        *ngIf="cf.fieldType!='Header'">
                        {{cf.fieldLabel}} <span *ngIf="cf.helpText" class="ml-2 custom_fields_info"
                          matTooltipClass="cmn-tooltip-template" matTooltip="{{cf.helpText}}">
                          <img src="../../../../assets/img/info-blue.svg" width="13px" loading="lazy" />
                        </span>
                      </h6>
                      <div class="col-7">
                        <!-- custom input field -->
                        <div class="form-input-container w-260" *ngIf="cf.fieldType=='Text'">
                          <input type="text" class="form-control" placeholder="" #value="ngModel" [(ngModel)]="cf.value"
                            name="value-{{i}}" autocomplete="off" maxlength="50" [placeholder]="cf.placeHolder"
                            [readonly]="cf.isReadOnly" />
                        </div>
                        <!-- custom input field end-->
                        <!-- custom Select field -->
                        <div class="form-select-container w-260" *ngIf="cf.fieldType=='Dropdown List'">
                          <ng-select class="cmn-ngselect wthout-ellipsis-option" name="cfdropdown-{{i}}"
                            [placeholder]="cf.placeHolder" bindLabel="dropvalue" bindValue="dropvalueId"
                            [items]="cf.cfdropdown" (clear)="onClearCustomFieldDropdown(cf)"
                            (ngModelChange)="eventChangeInqCustomDropdown($event)" #cfdropdown="ngModel"
                            [(ngModel)]="cf.value" [clearable]="cf.value">
                            <ng-template ng-label-tmp let-item="item">
                              <span [ngClass]="{'ng-select-custom-placeholder': !cf.value}">
                                {{item.dropvalue}}
                              </span>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-index="index">
                              <span [ngClass]="{'is-option-hidden': item.isHidden}"> {{item.dropvalue}}</span>
                            </ng-template>
                          </ng-select>
                        </div>
                        <!-- custom Select field end-->
                        <!-- custom checkbox field -->
                        <div *ngIf="cf.fieldType=='Checkbox'" class="customefields-checkboxes">
                          <div class="cmn-checkbox" *ngFor="let item of cf.cfdropdown">
                            <input id="cfchkbox-{{i}}-{{item.dropvalueId}}" type="checkbox"
                              class="check_box_add_contact_css check-label" value="" name="cfchkbox-{{i}}"
                              [checked]="item.status" (change)="chkqjobcustomfield($event,item.dropvalueId,i);" />
                            <label class="cmn-checkbox-text" for="cfchkbox-{{i}}-{{item.dropvalueId}}">
                              <span class="checkbox-square"></span>
                              {{item.dropvalue}}
                            </label>
                          </div>
                        </div>
                        <!-- custom checkbox field end-->
                        <!-- custom number field-->
                        <div class="form-input-container w-260" *ngIf="cf.fieldType=='Number'">
                          <input type="number" class="form-control" #value="ngModel" [(ngModel)]="cf.value"
                            name="value-{{i}}" autocomplete="off" [placeholder]="cf.placeHolder"
                            [readonly]="cf.isReadOnly"
                            onkeypress="javascript: return event.target.value.length > 15 ? false : true"
                            onkeydown="javascript: return event.keyCode == 69 ? false : true" />
                          <!-- onkeypress="javascript: return event.target.value.length > 7 ? false : true"-->
                        </div>
                        <!-- custom number field end-->
                        <!-- custom Link field-->
                        <div class="form-input-container w-260" *ngIf="cf.fieldType=='Link'">
                          <input type="text" class="form-control col-sm-12" #value="ngModel" [(ngModel)]="cf.value"
                            name="value-{{i}}" autocomplete="off" [placeholder]="cf.placeHolder"
                            [readonly]="cf.isReadOnly"
                            pattern="https?:\/\/(?:www\.)?[a-zA-Z0-9\-\.]+\.[a-z]{2,}(\/\S*)?"
                            (blur)="value.control.markAsTouched()" />
                          <div *ngIf="value.invalid && value.touched" class="text-danger">
                            <div *ngIf="value.errors?.['pattern']">Enter a valid URL (e.g., https://example.com).</div>
                          </div>
                        </div>
                        <!-- custom Link  field end-->
                        <!-- custom date field-->
                        <div class="form-datepicker-container w-260 mar_left_kc_test_date cmn-material-datepicker"
                          *ngIf="cf.fieldType=='Date'">
                          <mat-form-field floatLabel="never" appearance="standard">
                            <input class="cmn-mat-dtpicker-input" matInput #value="ngModel" [(ngModel)]="cf.value"
                              [matDatepicker]="CfPDateDatepicker" name="value-{{i}}" autocomplete="off"
                              placeholder="dd/mm/yyyy" [disabled]="cf.isReadOnly != 'readonly' ? false : true"
                              (ngModelChange)="onFormChange()">
                            <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix
                              [for]="CfPDateDatepicker"></mat-datepicker-toggle>
                            <mat-datepicker panelClass="cmn-datepicker-ui" #CfPDateDatepicker></mat-datepicker>
                            <mat-error class="cmn-material-datepicker-errormsg">
                              Please enter the date in dd/mm/yyyy
                            </mat-error>
                          </mat-form-field>
                          <!-- commented due to datepicker change -->
                          <!-- <ejs-datepicker
                                          format='dd/MM/yyyy' [placeholder]='cf.placeholder'
                                          [readonly]="cf.isReadOnly"
                                          name="value-{{i}}" #value="ngModel"
                                          [(ngModel)]="cf.value"
                                          openOnFocus='true' strictMode='true'></ejs-datepicker> -->
                        </div>
                        <div class="form-select-container w-260" *ngIf="cf.fieldType=='User'">
                          <div class="d-flex justify-content-start" *ngIf="!cf._isVisibleInput; else CfUserDropdown">
                            <div *ngFor="let item of cf?._userInfo|slice:0:2" class="profile-round-items">
                              <div class="profile_name_cicrle"
                                [ngStyle]="{'background-color': item.backgroundColor, 'color': item.textColor}"
                                matTooltipClass="cmn-tooltip-template" [matTooltip]="item.fullName">
                                {{ item.shortName }}
                              </div>
                            </div>
                            <div class="seemore-assignee-circle cursor-pointer" *ngIf="cf?._userInfo?.length>2"
                              [matMenuTriggerFor]="menus" #menuTrigger="matMenuTrigger"
                              (onclick)="closeSubMenu(menuTrigger)">
                              +{{cf?._userInfo?.length-2}}
                            </div>
                            <div class="addassignee-cicrcle-btn">
                              <button type="button" mat-button class="cmn-border-btn" (click)="showCFUserDropdown(cf)">
                                +
                              </button>
                            </div>
                            <mat-menu #menus="matMenu" [overlapTrigger]="false" [hasBackdrop]="true">
                              <div class="assignee-tooltip-items">
                                <div *ngFor="let item of cf?._userInfo | slice:2" class="assignee-tooltip-items-name">
                                  {{item.fullName}}
                                </div>
                              </div>
                            </mat-menu>
                          </div>
                          <ng-template #CfUserDropdown>
                            <div class="form-multiselect-container addnew-assignee-input">
                              <ng-multiselect-dropdown class="cmn-multiselect-dropdown flt-dropdown ellipsis-itemname"
                                [placeholder]="'Select'" [settings]="cfUserDropdownSetting"
                                [ngModelOptions]="{standalone: true}" [data]="cf.cfdropdown" [(ngModel)]="cf.value"
                                (onDropDownClose)="hideCFUserDropdown(cf)" (ngModelChange)="onCFUserDropdownChange(cf)">
                              </ng-multiselect-dropdown>
                            </div>
                          </ng-template>
                        </div>
                        <!-- custom date field end-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- custom fields content end-->
            </div>
            </div>
            <!-- screen 1 code end-->
            <!-- next screen2 assignee code -->
            <div *ngIf="currentScreenActive == 2">
              <!-- <div class="create-Job-Table" *ngIf="createJobTableShow"> -->
              <div class="create-Job-Table" *ngIf="true">
                <div class="cmn-createjob-Popup-Ui-row asignstaff-and-task-row">
                  <!-- left col -->
                  <div class="cmn-createjob-Popup-Ui-row-col asignstaff-and-task-col">
                    <h5 class="fields-type-title">Assign staff</h5>
                    <div class="cmn-table-design assignstaffestimate-table-conainer">
                      <!-- <table class="table table-borderless marign_table_job">
                                <thead class="kc-table-head">
                                  <tr>
                                    <th scope="col" style="width:30%">Assignee name</th>
                                    <th scope="col" style="width:15%">Role</th>
                                    <th scope="col" style="width:20%"><div class="d-flex justify-content-end"><p class="kc_est">Time </p></div></th>
                                    <th scope="col" style="width:13%">

                                      <div class="d-flex justify-content-end kc-estimate"><p class="kc_est"> Billing rate </p></div>

                                    </th>
                                    <th scope="col" style="width:13%">
                                      <div class="d-flex justify-content-end kc-estimate"><p class="kc_est"> Cost </p></div>


                                    </th>
                                    <th>

                                      &nbsp;

                                    </th>
                                  </tr>
                                </thead>
                                <tbody class="kc_global_tb kc_global_tbody">
                                  <tr *ngFor="let _item of _lstTempAssignee; let i=index">
                                    <td class="assign_td">
                                      <div class="assigneespace">
                                        <div class="form-select-container w-200">
                                            <ng-select [items]="users" class="cmn-ngselect cmn-assign-staff-jobs"
                                                      bindLabel="firstName"
                                                      bindValue="userId" id="mainselection"
                                                      [clearable]="true" name="assignee" #assignee="ngModel" (change)="onItemSelect($event,i)" [ngModelOptions]="{standalone: true}"
                                                      placeholder="Select Assignee" [(ngModel)]="_item.userId" [readonly]="_item.isManagerPartner == 1 && _item.role == 'Partner'">

                                              <ng-template ng-option-tmp let-item="item" let-index="index">
                                                <div class="cmn-ngselect-role-tmplt">
                                                  <div class="role-item-nametext" title="{{item.firstName}}">{{item.firstName.length > 15 ? (item.firstName| slice:0:15) + '..' : item.firstName}}</div>
                                                  <p class="role-value-text" title="{{item.roleName}}">
                                                    <img src="../../../../assets/img/role-ic.svg" alt="icon" /> {{item.roleName}}
                                                  </p>
                                                </div>
                                              </ng-template>
                                            </ng-select>
                                        </div>
                                      </div>
                                    </td>
                                    <td class="padding_left_css_add_job assign_td">{{_item.role}}</td>

                                    <td class="assign_td">
                                      <div class="form-input-container">
                                        <input class="form-control new_text inpt font-size-kc-cmd" type='text'(keypress)="numberOnly($event)" maxlength="6" value="{{_item.time}}" [ngModelOptions]="{standalone: true}" [(ngModel)]="_item.time" (blur)="CalculateCost(_item)" placeholder="hh:mm" (keydown.enter)="CalculateCost(_item)" />
                                      </div>
                                    </td>
                                    <td class="assign_td">
                                      <div class="form-select-container w-120 cmn-rate-dropdown-template">
                                        <ng-select [items]="_item.multiBillrates" [(ngModel)]="_item._billrateId" [ngModelOptions]="{standalone: true}" (change)="onBillRateSelect($event,i)"
                                                  class="cmn-ngselect cmn-assign-staff-jobs"
                                                  bindLabel="getLabel"
                                                  bindValue="billRateId"
                                                  [clearable]="false"
                                                  [searchable]="false"
                                                  placeholder="$0.00">
                                          <ng-template ng-option-tmp let-item="item" let-index="index">
                                            <div class="cmn-rate-dropdown-option-tmp">
                                              <span>{{ item.mRdescription }}</span>
                                              <span>{{ item.billrate | currency:CurrencyPipe }}</span>
                                            </div>
                                          </ng-template>
                                        </ng-select>
                                                        </div>

                                    </td>
                                    <td class="assign_td">
                                      <div class="d-flex justify-content-end  kc-estimate pl-2">
                                        <p class="kc_est">  {{_item.cost == '-' ? _item.cost :_item.cost | currency:CurrencyPipe}} </p>
                                      </div>
                                    </td>
                                    <td class="table-data create-invoice-data create-quote-data close-data assign_td" *ngIf="_item.isManagerPartner==1">
                                    </td>
                                    <td class="table-data create-invoice-data create-quote-data close-data assign_td" *ngIf="_item.isManagerPartner!=1">
                                      <i class="fa fa-times timenarbutton" (click)="DeleteAssigneeStaff(_item.userId, i)"></i>
                                    </td>
                                  </tr>
                                  <tr class="addnew-action-row">
                                    <td class="assign_td">
                                      <div class="add_css_email">
                                        <label class="add_email_css add_email_new" (click)="Addrow()">+Add Row</label>
                                      </div>
                                    </td>
                                    <td class="padding_left_css_add_job">&nbsp;</td>
                                    <td class="assign_td">
                                      &nbsp;
                                    </td>
                                    <td class="assign_td">
                                      &nbsp;
                                    </td>
                                    <td class="assign_td">
                                      &nbsp;
                                    </td>
                                    <td class="assign_td">
                                      &nbsp;
                                    </td>
                                  </tr>
                                  <tr class="table_job_data_css">
                                    <td colspan="4" *ngIf="TimeErrorMsg" class="border_bottom_css_table ">
                                      <span class="invalid-feedback invalid mr_left_job_table">
                                        *Partner & Manager are must be assignees
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td class="assign_td_one text-right">
                                      <span class="kc_job_total pr-2"> Total</span>
                                    </td>
                                    <td class="assign_td_one">
                                      &nbsp;
                                    </td>
                                    <td class="assign_td_one">
                                      <div class="d-flex justify-content-end  kc-estimate">
                                        <p class="kc_est kc_total_time"> {{totalassignedtime}} </p>
                                      </div>
                                    </td>
                                    <td class="assign_td_one">
                                      <span class="kc_count kc-total-rates">
                                        &nbsp;
                                      </span>
                                    </td>
                                    <td class="assign_td_one">
                                      <div class="d-flex justify-content-end  kc-estimate pl-2">
                                        <p class="kc_est kc_total_times kc-total-cost"> {{totalcost == '-' ? totalcost : totalcost | currency:CurrencyPipe}} </p>
                                      </div>
                                    </td>
                                    <td class="assign_td_one">
                                      &nbsp;
                                    </td>
                                  </tr>
                                </tfoot>
                              </table> -->
                      <!-- new table UI end -->
                      <!-- CUST-4339 table updated UI for task -->
                      <table class="table table-borderless mb-0 assign-staff-table-wthut-group" data-testid="table-client-job-assign-staff">
                        <thead>
                          <tr>
                            <th>Staff</th>
                            <th>Job Role</th>
                            <th class="text-center">
                              <div class="d-flex align-items-cente justify-content-center position-relative">
                                Estimate <img src="../../../../assets/img/info-blue-ic.svg" alt="icon" width="16"
                                  matTooltipClass="cmn-tooltip-template hide-tooltip-arrow"
                                  matTooltip="1 unit = {{firmSetting.unitvalue}} minutes" class="estimate-info-icon">
                              </div>
                            </th>
                            <th class="text-center">Time</th>
                            <th class="text-right">Billing Rate</th>
                            <th class="text-right">Cost</th>
                          </tr>
                        </thead>
                        <tbody>
                          <!-- user list row loop -->
                          <tr *ngFor="let assignee of assignAndEstimate.Assign.staff; let i = index">
                            <td>
                              <div class="form-select-container select-assignee-dropdwn">
                                <ng-container
                                  *ngIf="assignee.isJobLevelUser || assignee.isTimesheetEntry; else userSelectDropdown">
                                  {{assignee.fullName || 'Unassigned'}}
                                </ng-container>
                                <ng-template #userSelectDropdown>
                                  <ng-select [items]="assignee._availableUserOptions"
                                    class="cmn-ngselect cmn-assign-staff-jobs users-ng-select" bindValue="userId"
                                    bindLabel="fullName" [id]="'mainselection-' + assignee.jobLevelRoleName + '-' + i"
                                    [name]="'assignee-' + assignee.jobLevelRoleName + '-' + i" [clearable]="false"
                                    [(ngModel)]="assignee.userId" placeholder="Unassigned"
                                    (focus)="onAssigneeSelectionFocus(assignee)"
                                    (change)="onAssigneeSelectionChange($event, assignee)" data-testid="drpdwn-client-job-assign-staff">
                                    <ng-template ng-option-tmp let-item="item" let-index="index">
                                      <div class="cmn-ngselect-role-tmplt"
                                        *ngIf="!item.isSeparator; else separatorTemplate">
                                        <div class="role-item-nametext" title="{{item.fullName}}">
                                          {{item.fullName?.length > 15 ? (item.fullName | slice:0:15) + '..' :
                                          item.fullName}}
                                        </div>
                                        <p class="role-value-text" title="{{item.roleName}}">
                                          <img src="../../../../assets/img/role-ic.svg" alt="icon" />
                                          {{item.roleName}}
                                        </p>
                                      </div>
                                    </ng-template>
                                    <ng-template #separatorTemplate>
                                      <div class="jobline-teams" [disabled]="true"></div>
                                    </ng-template>
                                  </ng-select>
                                </ng-template>
                              </div>
                            </td>
                            <td>
                              <ng-container
                                *ngIf="assignee.isFirstUserForRole || assignee.isTimesheetEntry; else roleSelectDropdown">
                                {{assignee.jobLevelRoleName}}
                              </ng-container>
                              <ng-template #roleSelectDropdown>
                                <div class="form-select-container jobjrole-dropdwn">
                                  <ng-select [name]="'assigneeRole-' + i" [items]="assignee._availableRoleOptions"
                                    class="cmn-ngselect cmn-assign-staff-jobs users-ng-select" bindValue="roleId"
                                    bindLabel="roleName" [clearable]="false" [(ngModel)]="assignee.jobLevelRoleId"
                                    [searchable]="false" placeholder="Select job role"
                                    (focus)="onAssigneeRoleSelectionFocus(assignee)"
                                    (change)="onChangeAssigneeRole($event, assignee)" data-testid="drpdwn-client-job-assign-role">
                                    <ng-template ng-option-tmp let-item="item" let-index="index">
                                      <span title="{{item.roleName}}">{{item.roleName}}</span>
                                    </ng-template>
                                  </ng-select>
                                </div>
                              </ng-template>
                            </td>
                            <td class="text-center">
                              <ng-container *ngIf="jobDataModal.jobEstimateType === 'Task'; else JobTypeUnits">
                                {{assignee.unit ? assignee.unit : "-"}}
                              </ng-container>
                              <ng-template #JobTypeUnits>
                                <div class="assignstaff-estimate-inpt">
                                  <input type="number" min="0" class="form-control" name='assigneeUnit-{{i}}'
                                    (keypress)="numberOnly($event)" [(ngModel)]="assignee.unit"
                                    (blur)="onAssigneeUnitBlur(assignee)">
                                </div>
                              </ng-template>
                            </td>
                            <td class="text-center">
                              {{assignee.time ? assignee.time : "-"}}
                            </td>
                            <td class="text-center">
                              <ng-container *ngIf="assignee.userId;else OnlyRate">
                                <div class="form-select-container cmn-rate-dropdown-template">
                                  <ng-select [items]="assignee.userRates" class="cmn-ngselect cmn-assign-staff-jobs"
                                    bindLabel="ValueAmt" bindValue="ValueAmt" [clearable]="false"
                                    [id]="'assigneeRate' + i" [name]="'assigneeRate' + i"
                                    [(ngModel)]="assignee.selectedRate" (ngModelChange)="calculateCost(assignee)"
                                    [searchable]="false" placeholder="$0.00"  data-testid="drpdwn-client-job-assign-billing-rate">
                                    <ng-template ng-option-tmp let-item="item" let-index="index">
                                      <div class="cmn-rate-dropdown-option-tmp">
                                        <span>{{item.valuelabel}}</span>
                                        <span>{{item.ValueAmt}}</span>
                                      </div>
                                    </ng-template>
                                  </ng-select>
                                </div>
                              </ng-container>
                              <ng-template #OnlyRate>
                                {{assignee.selectedRate || '-'}}
                              </ng-template>
                            </td>
                            <td class="text-right">
                              ${{assignee.cost ? assignee.cost : "0"}}
                            </td>
                          </tr>
                          <!-- add new child row button -->
                          <tr class="assignstaff-tbl-addnewrow">
                            <td colspan="6" class="addnew-row-btn-td">
                              <button type="button" mat-button class="cmn-link-btn" (click)="addNewAssigneeRow()" data-testid="btn-client-job-add-assignee">
                                + Add a row
                              </button>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td>Total</td>
                            <td></td>
                            <td class="text-center">{{totalAssignStaffEstimate ? totalAssignStaffEstimate :
                              assignAndEstimate.Assign._totalUnit}}</td>
                            <td class="text-center">{{totalAssignStaffTime}}</td>
                            <td class="text-right"></td>
                            <td class="text-right">${{totalAssignStaffCost}}</td>
                          </tr>
                        </tfoot>
                      </table>
                      <!-- CUST-4339 table updated UI for task end -->
                    </div>
                  </div>
                  <!-- left col end -->
                  <!-- right col -->
                  <div class="cmn-createjob-Popup-Ui-row-col asignstaff-and-task-col">
                    <!-- if estimate column is there, then estimate word will come with below title-->
                    <h5 class="fields-type-title pl-0">Task <ng-container
                        *ngIf="jobDataModal.jobEstimateType === 'Task'">estimate</ng-container></h5>
                    <!-- task estimate UI -->
                    <div class="task-estimate-container">
                      <!-- table header CUST-4509 -->
                      <div class="tasktable-cmn-header-tbl">
                        <div class="cmn-table-design task-estimate-tbl">
                          <table class="table table-borderless mb-0" data-testid="table-client-job-task-estimate">
                            <thead>
                              <tr>
                                <th class="taskname-col-wdth">Task Name</th>
                                <th class="taskestimate-fix-col">Job Role</th>
                                <th class="taskestimate-fix-col">Assignee</th>
                                <th class="text-center taskestimate-fix-estimate"
                                  *ngIf="jobDataModal.jobEstimateType === 'Task'">
                                  <div class="d-flex align-items-center justify-content-center position-relative">
                                    Estimate <img src="../../../../assets/img/info-blue-ic.svg" alt="icon" width="16"
                                      matTooltipClass="cmn-tooltip-template hide-tooltip-arrow"
                                      matTooltip="1 unit = {{firmSetting.unitvalue}} minutes"
                                      class="estimate-info-icon">
                                  </div>
                                </th>
                              </tr>
                            </thead>
                          </table>
                        </div>
                      </div>
                      <!-- table header CUST-4509 end -->
                      <div *ngIf="assignAndEstimate?.Estimate?.length; else noDataFound">
                        <div class="task-estimate-accordion-list">
                          <div class="task-estimate-accordion-list-row"
                            *ngFor="let group of assignAndEstimate.Estimate; let group_index = index ">
                            <div class="task-estimate-accordion-list-row-heading collapsed" data-bs-toggle="collapse"
                              [attr.data-bs-target]="'#taskEstimateRow-' + group.taskgroupId" aria-expanded="false"
                              [attr.aria-controls]="'taskEstimateRow-' + group.taskgroupId">
                              <span class="estimatrow-toggle-btn">
                                <i class="fa fa-chevron-right"></i>
                              </span>
                              {{ group.taskGroupName }}
                              <ng-container *ngIf="jobDataModal.jobEstimateType === 'Task'"> | Total : {{
                                totalGroupUnit(group_index) }} units </ng-container>
                              <ng-container *ngFor="let user of group._groupAssigneeOverview">
                                | {{user.name}}
                                <ng-container *ngIf="jobDataModal.jobEstimateType === 'Task'">: {{user.unit}} units
                                </ng-container>
                              </ng-container>
                            </div>
                            <div class="task-estimate-accordion-list-row-content collapse"
                              id="taskEstimateRow-{{group.taskgroupId}}">
                              <div class="cmn-table-design task-estimate-tbl">
                                <table class="table table-borderless mb-0"  data-testid="table-client-job-task-estimate-details">
                                  <tbody>
                                    <tr *ngFor="let task of group.tasks;let task_index = index">
                                      <td class="taskname-col-wdth">
                                        <div class="task-estimate-tbl-taskname">
                                          <p class="mb-0">{{task.taskName}}</p>
                                        </div>
                                      </td>
                                      <td class="taskestimate-fix-col">
                                        <div class="task-estimate-tbl-taskname">
                                          <p class="mb-0 rolename-value"
                                            matTooltipClass="cmn-tooltip-template light-tooltip-template"
                                            [matTooltip]="task._taskRoleNames">{{task._taskRoleNames}}</p>
                                        </div>
                                      </td>
                                      <td class="taskestimate-fix-col">
                                        <div class="d-flex justify-content-start"
                                          *ngIf="task._breakdownAvailableType !== 'Assignee'">
                                          <ng-container *ngIf="task?._estimateDataListUnsaved?.length; else unassigned">
                                            <div *ngFor="let asname of task?._estimateDataListUnsaved|slice:0:2"
                                              class="profile-round-items">
                                              <div *ngIf="asname.userId; else unassigned" class="profile_name_cicrle"
                                                [ngStyle]="{'background-color': '#d8efea', 'color': '#0e4e40'}"
                                                matTooltipClass="cmn-tooltip-template" [matTooltip]="asname.fullName">
                                                {{ asname.initials }}
                                              </div>
                                            </div>
                                            <div class="seemore-assignee-circle cursor-pointer"
                                              *ngIf="task?._estimateDataListUnsaved?.length>2"
                                              [matMenuTriggerFor]="menus" #menuTrigger="matMenuTrigger"
                                              (onclick)="closeSubMenu(menuTrigger)">
                                              +{{task?._estimateDataListUnsaved?.length-2}}
                                            </div>
                                          </ng-container>
                                          <ng-template #unassigned>
                                            <div class="unassigned_user">
                                              <img src="../../../../assets/img/unassigned_icon.svg"
                                                matTooltipClass="cmn-tooltip-template" matTooltip="Unassigned">
                                            </div>
                                          </ng-template>

                                          <div class="addassignee-cicrcle-btn">
                                            <button type="button" [ngClass]="{'disabled': false}" mat-button
                                              class="cmn-border-btn"  data-testid="btn-client-job-task-estimate-add-assignee"
                                              (click)="showAvailableBreakdown(task, 'Assignee')">+</button>
                                          </div>
                                          <mat-menu #menus="matMenu" [overlapTrigger]="false" [hasBackdrop]="true">
                                            <div class="assignee-tooltip-items">
                                              <div *ngFor="let asname of task?._estimateDataListUnsaved | slice:2"
                                                class="assignee-tooltip-items-name">
                                                {{asname.fullName || 'Unassigned'}}
                                              </div>
                                            </div>
                                          </mat-menu>
                                        </div>
                                        <!-- add new assignee -->
                                        <div class="form-multiselect-container addnew-assignee-input"
                                          *ngIf="task._breakdownAvailableType === 'Assignee'">
                                          <!-- <ng-multiselect-dropdown class="cmn-multiselect-dropdown flt-dropdown ellipsis-itemname"
                                                                          [placeholder]="'Select assignee'" [settings]="taskassigneesListConfig" [ngModelOptions]="{standalone: true}"
                                                                          [(ngModel)]="task._selectedUsers" (onDropDownClose)="onDropdownBlur(task)"
                                                                          [data]="task._availableUserForTask" (ngModelChange)="onChangeUserForTask(task)">
                                                                      </ng-multiselect-dropdown> -->
                                          <!-- CUST-4509 UI -->
                                          <div class="treegridUI-edit-dropdwn-template assignee-col-edit"
                                            [ngClass]="{'isbreakdownActive' : task._breakdownOpenType}">
                                            <div class="editinput-control-template"
                                              (click)="openBreakdownPopup(task, 'Assignee')">
                                              <div class="editinput-tagsitem"
                                                *ngIf="task._estimateDataListUnsaved?.length">
                                                <span class="tags-itemname"
                                                  title="{{task._estimateDataListUnsaved[0]?.fullName}}">{{task._estimateDataListUnsaved[0]?.fullName
                                                  || 'Unassigned'}}</span>
                                              </div>
                                              <div class="ml-auto" *ngIf="task._estimateDataListUnsaved?.length > 1">
                                                <span
                                                  class="editinput-control-counter">+{{task._estimateDataListUnsaved.length-1}}</span>
                                              </div>
                                              <span *ngIf="_estimateDataListUnsaved?.length > 1"
                                                class="editinput-control-counter">+{{_estimateDataListUnsaved?.length
                                                -1}}</span>
                                            </div>
                                            <!-- dropdown content -->
                                            <ng-container *ngIf="task._breakdownOpenType === 'Assignee'">
                                              <ng-template
                                                *ngTemplateOutlet="TaskEstimate; context: {task: task, task_index: task_index, group_index: group_index}"></ng-template>
                                            </ng-container>
                                          </div>
                                          <!-- CUST-4509 UI end -->
                                        </div>
                                        <!-- add new assignee end -->
                                      </td>
                                      <td class="text-left taskestimate-fix-estimate"
                                        *ngIf="jobDataModal.jobEstimateType === 'Task'">
                                        <!-- CUST-4509 UI -->
                                        <div class="treegridUI-edit-dropdwn-template unit-column-temlt"
                                          [ngClass]="{'isbreakdownActive' : task._breakdownAvailableType === 'Estimate'}">
                                          <button type="button" class="editinput-control-template"
                                            (click)="openBreakdownPopup(task, 'Estimate')"  data-testid="btn-client-job-task-estimate">
                                            {{task._selectedUsers?.length ? task.assignedUnit : task.unit}}
                                          </button>
                                          <!-- dropdown content -->
                                          <ng-container *ngIf="task._breakdownOpenType === 'Estimate'">
                                            <ng-template
                                              *ngTemplateOutlet="TaskEstimate; context: {task: task, task_index: task_index, group_index: group_index}"></ng-template>
                                          </ng-container>
                                        </div>
                                        <!-- CUST-4509 UI end -->
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div class="norecord-message-text" *ngIf="group.tasks.length == 0">
                                  No records found.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <ng-template #noDataFound>
                        <div class="no-task-found-template">
                          <img src="../../../../assets/img/blank-task-image.svg" alt="blank-img">
                          <h6>No task</h6>
                          <i class="error-text">No tasks are currently associated with this job.</i>
                        </div>
                      </ng-template>

                    </div>
                    <!-- task estimate UI end -->
                  </div>
                  <!-- right col end -->
                </div>

              </div>
            </div>
            <!-- next screen2 assignee code  end-->
            <!-- screen 3 recurrence -->
            <div *ngIf="currentScreenActive == 3">
              <div class="cmn-createjob-Popup-Ui-row asignstaff-and-task-row">
                <!-- left col -->
                <div class="cmn-createjob-Popup-Ui-row-col-left asignstaff-and-task-col">
                  <div class="recurrence-screen-container">
                    <!-- recurrence content -->
                    <!-- <div class="jobrecurrence-content" *ngIf="recurrenceEnableChk"> -->
                    <div class="jobrecurrence-content">
                      <div class="form-group pt-2" *ngIf="false"> <!-- this form group control will delete content -->
                        <div class="custom-row">
                          <h6 class="cmn-form-label mb-0 text-left col-5 recurrence-formlabel-pl">
                            Job recurrence
                          </h6>
                          <div class="col-7">

                            <div class="cmn-slide-toggle-container">
                              <mat-slide-toggle class="fn_sz" name="prospect" color="primary"
                                [(ngModel)]="recurrenceEnableChk" data-testid="toggle-client-job-recurrence"></mat-slide-toggle>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group" *ngIf="false"> <!-- this form group control will delete content -->
                        <div class="custom-row align-items-center">
                          <h6 class="cmn-form-label mb-0 text-left col-5 recurrence-formlabel-pl">
                            Financial year
                          </h6>
                          <div class="col-7">
                            <div class="cmn-form-label mb-0">
                              {{recurranceData.FY}}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="custom-row align-items-center">
                          <h6 class="cmn-form-label mb-0 text-left col-5 recurrence-formlabel-pl">
                            Frequency
                          </h6>
                          <div class="col-7">
                            <fieldset [disabled]="isEditMode">
                              <div class="form-radio-inline frequency-radiobtn"
                                [ngClass]="{'isDisableRadioBtn':isEditMode}">
                                <div *ngIf="(jobselectedFrequency !== 'Monthly' &&  jobselectedFrequency !== 'Quarterly') || recurrenceEnableChk " class="fncy-radio-button form-check-inline">
                                  <input type="radio" [disabled]="isEditMode" name="FrequencyRadio"
                                    [(ngModel)]="recurranceData.Frequency" (change)="onChangeRecurranceFrequency()"
                                    [ngModelOptions]="{standalone: true}" value="Annually" data-testid="radio-client-job-frequency-annually"/>
                                  <label class="radio-btn-label">Annually</label>
                                </div>
                                <div class="fncy-radio-button form-check-inline"
                                  [ngClass]="{'isDisableRadioBtn':!recurrenceEnableChk || isEditMode}">
                                  <input type="radio" [disabled]="isEditMode" name="FrequencyRadio"
                                    [(ngModel)]="recurranceData.Frequency" (change)="onChangeRecurranceFrequency()"
                                    [ngModelOptions]="{standalone: true}" value="Quarterly" data-testid="radio-client-job-frequency-quarterly" />
                                  <label class="radio-btn-label">Quarterly</label>
                                </div>
                                <div class="fncy-radio-button form-check-inline mr-0"
                                  [ngClass]="{'isDisableRadioBtn':!recurrenceEnableChk || isEditMode}">
                                  <input type="radio" [disabled]="isEditMode"
                                    name="FrequencyRadio" [(ngModel)]="recurranceData.Frequency"
                                    (change)="onChangeRecurranceFrequency()" [ngModelOptions]="{standalone: true}"
                                    value="Monthly" data-testid="radio-client-job-frequency-monthly" />
                                  <label class="radio-btn-label">Monthly</label>
                                </div>
                              </div>
                            </fieldset>
                          </div>
                        </div>
                      </div>
                      <!-- based on frequency show hide this control -->
                      <div class="form-group" *ngIf="recurranceData.Frequency !== 'Annually'">
                        <div class="custom-row align-items-center">
                          <h6 class="cmn-form-label mb-0 text-left col-5 recurrence-formlabel-pl">
                            Period
                          </h6>
                          <div class="col-7">
                            <!-- monthly dropdown -->
                            <div class="form-multiselect-container w-260"
                              *ngIf="recurranceData.Frequency === 'Monthly'">
                              <ng-multiselect-dropdown class="cmn-multiselect-dropdown flt-dropdown ellipsis-itemname"
                              data-testid="drpdwn-client-job-period-monthly"
                                [placeholder]="'Select period'" name="recurranceMonthly" #recurranceMonthly="ngModel"
                                [(ngModel)]="recurranceData.Period" [settings]="frequencyConfig"
                                [disabled]=" isEditMode" [data]="frequencyMonthList"
                                (ngModelChange)="onPeriodChange($event)">
                              </ng-multiselect-dropdown>
                            </div>
                            <!-- monthly dropdown end-->
                            <!-- quarterly-->
                            <div class="form-multiselect-container w-260"
                              *ngIf="recurranceData.Frequency === 'Quarterly'">
                              <ng-multiselect-dropdown class="cmn-multiselect-dropdown flt-dropdown ellipsis-itemname"
                              data-testid="drpdwn-client-job-period-quarterly"
                                [placeholder]="'Select period'" name="recurranceQuarterly"
                                #recurranceQuarterly="ngModel" [(ngModel)]="recurranceData.Period"
                                [settings]="frequencyQuarterConfig" [disabled]=" isEditMode"
                                [data]="frequencyQuarterList" (ngModelChange)="onQuarterChange($event)">
                              </ng-multiselect-dropdown>
                            </div>
                            <!-- quarterly end-->
                          </div>
                        </div>
                      </div>
                      <!-- based on frequency show hide this control end-->
                      <div class="form-group">
                        <div class="custom-row align-items-center">
                          <h6 class="cmn-form-label mb-0 text-left col-5 recurrence-formlabel-pl">
                            Start recurrence<span class="color_job_css">*</span>
                          </h6>
                          <div class="col-7">
                            <div class="form-datepicker-container cmn-material-datepicker w-260">
                              <mat-form-field floatLabel="never" appearance="standard">
                                <input class="cmn-mat-dtpicker-input" matInput
                                data-testid="input-datepicker-start-recurrence"
                                  [matDatepicker]="recurranceStartDateDatepicker" name="recurranceStartDate"
                                  autocomplete="off" placeholder="dd/mm/yyyy" #recurranceStartDate="ngModel"
                                  (dateChange)="onStartRecurrenceDateChange($event)"  [required]="!recurrenceEnableChk ? false : true"
                                  [(ngModel)]="recurranceData.Start_ReccDate" 
                                  [disabled]="!recurrenceEnableChk || isEditMode"  data-testid="input-datepicker-stop-recurrence">
                                <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix
                                  [for]="recurranceStartDateDatepicker"></mat-datepicker-toggle>
                                <mat-datepicker panelClass="cmn-datepicker-ui"
                                  #recurranceStartDateDatepicker></mat-datepicker>
                                <mat-error class="cmn-material-datepicker-errormsg">
                                  Please enter the date in dd/mm/yyyy
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="custom-row align-items-center">
                          <h6 class="cmn-form-label mb-0 text-left col-5 recurrence-formlabel-pl">
                            Stop recurrence<span class="color_job_css"></span>
                          </h6>
                          <div class="col-7">
                            <div class="form-datepicker-container cmn-material-datepicker w-260">
                              <mat-form-field floatLabel="never" appearance="standard">
                                <input class="cmn-mat-dtpicker-input" matInput
                                  [matDatepicker]="recurranceStopDateDatepicker" name="recurranceStopDate"
                                  autocomplete="off" placeholder="dd/mm/yyyy" #recurranceStopDate="ngModel"
                                  [(ngModel)]="recurranceData.Stop_ReccDate" [min]="mindueDate"
                                  [disabled]="!recurrenceEnableChk || isEditMode">
                                <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix
                                  [for]="recurranceStopDateDatepicker"></mat-datepicker-toggle>
                                <mat-datepicker panelClass="cmn-datepicker-ui"
                                  #recurranceStopDateDatepicker></mat-datepicker>
                                <!-- <mat-error class="cmn-material-datepicker-errormsg" *ngIf="!recurranceStopDate.hasError('matDatepickerMin')">
                                              Please enter the date in dd/mm/yyyy
                                          </mat-error>
                                          <mat-error class="cmn-material-datepicker-errormsg" *ngIf="recurranceStopDate.hasError('matDatepickerMin')">
                                              Please enter a valid Due Date
                                          </mat-error> -->
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      </div>
                      <h6 *ngIf="(jobselectedFrequency !== 'Monthly' &&  jobselectedFrequency !== 'Quarterly') || recurrenceEnableChk " class="carryfwd-title">Carry forward</h6>
                      <div *ngIf="(jobselectedFrequency !== 'Monthly' &&  jobselectedFrequency !== 'Quarterly') || recurrenceEnableChk " class="form-group">
                        <div class="custom-row align-items-center">
                          <h6 class="cmn-form-label mb-0 text-left col-5 recurrence-formlabel-pl">
                            Task
                          </h6>
                          <div class="col-7">
                            <div class="form-select-container w-260">
                              <ng-select [disabled]="!recurrenceEnableChk || isEditMode" [items]="carryFwdTaskOption"
                                class="cmn-ngselect" bindLabel="value" bindValue="value" [clearable]="false"
                                [searchable]="false" [(ngModel)]="recurranceData.TaskCarryForward"
                                (ngModelChange)="onTaskCarryForwardChange($event)" [ngModelOptions]="{standalone: true}"
                                placeholder="Select" data-testid="drpdwn-client-job-carryforward-task">
                              </ng-select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="(jobselectedFrequency !== 'Monthly' &&  jobselectedFrequency !== 'Quarterly') || recurrenceEnableChk " class="form-group">
                        <div class="custom-row align-items-center">
                          <h6 class="cmn-form-label mb-0 text-left col-5 recurrence-formlabel-pl">
                            Assignee
                          </h6>
                          <div class="col-7">
                            <div class="control-wth-infoicon">
                              <div class="form-select-container w-260">
                                <ng-select [items]="carryFwdAssigneeOption" class="cmn-ngselect" bindLabel="value"
                                  bindValue="value" [(ngModel)]="recurranceData.AssigneeCarryForward"
                                  [ngModelOptions]="{standalone: true}" [clearable]="false"
                                  (ngModelChange)="onAssigneeCarryForwardChange($event)" [searchable]="false"
                                  placeholder="Select" data-testid="drpdwn-client-job-carryforward-assignee"
                                  [disabled]="!recurrenceEnableChk || isEditMode || isCarryForword">
                                </ng-select>
                              </div>
                              <!-- <span class="controlinfo-tooltip">
                                              <img src="../../../../assets/img/info_icon.svg" alt="icon"
                                                  matTooltipClass="cmn-tooltip-template"
                                                  matTooltip="Lorem ipsum">
                                          </span> -->
                            </div>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="(jobselectedFrequency !== 'Monthly' &&  jobselectedFrequency !== 'Quarterly') || recurrenceEnableChk " class="form-group mb-0">
                        <div class="custom-row align-items-center">
                          <h6 class="cmn-form-label mb-0 text-left col-5 recurrence-formlabel-pl">
                            Estimate
                          </h6>
                          <div class="col-7">
                            <div class="control-wth-infoicon">
                              <div class="form-select-container w-260">
                                <ng-select [items]="carryFwdBudgetOption" class="cmn-ngselect" bindLabel="value"
                                  bindValue="value" [(ngModel)]="recurranceData.BudgetCarryForward"
                                  [ngModelOptions]="{standalone: true}" [clearable]="false" [searchable]="false"
                                  placeholder="Select" [disabled]="!recurrenceEnableChk || isEditMode" data-testid="drpdwn-client-job-carryforward-task">
                                </ng-select>
                              </div>
                              <!-- <span class="controlinfo-tooltip">
                                              <img src="../../../../assets/img/info_icon.svg" alt="icon"
                                                  matTooltipClass="cmn-tooltip-template"
                                                  matTooltip="Lorem ipsum">
                                          </span> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- recurrence content end -->
                  </div>
                </div>
                <!-- left col end -->
                <!-- right col -->
                <div class="cmn-createjob-Popup-Ui-row-col-right asignstaff-and-task-col">
                  <div class="periods_date_section">
                    <div class="periods_title">Period Start & End</div>
                    <div class="cmn-table-design periods_table_recurrence montly_table"
                      *ngIf="recurranceData.Frequency === 'Monthly'">
                      <table class="table table-borderless mb-0" *ngIf="monthFlagCheck"  data-testid="table-monthly-table-period-start-end">
                        <colgroup>
                          <col width="12%" />
                          <col width="88%" />
                        </colgroup>
                        <tbody>
                          <tr *ngFor="let periodData of datas; let i = index">
                            <td [hidden]="!periodData.isEnabled"><span>{{ periodData.monthly }}</span></td>
                            <td class="period_selection_column_row" [hidden]="!periodData.isEnabled">
                              <div class="period_selection_column">
                                <span class="period_labels">Starts</span>
                                <span class="startdate_select">
                                  <div class="form-select-container border-lined"
                                    [ngClass]="{'error_field':formSubmitted &&  validationStates[i] && periodData.isEnabled}">
                                    <ng-select [items]="StartsDate" class="cmn-ngselect" bindLabel="startsWeek"
                                      bindValue="startsId" [searchable]="false" [clearable]="false" data-testid="drpdwn-monthly-table-period-starts-date"
                                      [(ngModel)]="periodData.selctedStartsDate" [disabled]="!periodData.isEnabled"
                                      [ngModelOptions]="{standalone: true}" (change)="onSelectionChange(periodData)">
                                    </ng-select>
                                  </div>
                                </span>
                                <span class="startweek_select">
                                  <div class="form-select-container border-lined"
                                    [ngClass]="{'error_field': formSubmitted && validationStates[i] && periodData.isEnabled}">
                                    <ng-select [items]="StartsWeek" class="cmn-ngselect" bindLabel="StartsWeekDay"
                                      bindValue="WeekId" [searchable]="false" [clearable]="false"  data-testid="drpdwn-monthly-table-period-starts-week"
                                      [(ngModel)]="periodData.selctedStartsDay" [disabled]="!periodData.isEnabled"
                                      [ngModelOptions]="{standalone: true}" (change)="onSelectionChange(periodData)">
                                    </ng-select>
                                  </div>
                                </span>
                                <span class="period_labels">of</span>
                                <span class="startmonth_select">
                                  <div class="form-select-container border-lined"
                                    [ngClass]="{'error_field': formSubmitted && validationStates[i] && periodData.isEnabled}">
                                    <ng-select [items]="StartsMonth" class="cmn-ngselect" bindLabel="StartMonth"
                                      bindValue="StartsMonthId" [searchable]="false" [clearable]="false"
                                      data-testid="drpdwn-monthly-table-period-starts-month"
                                      [(ngModel)]="periodData.selctedStartsMonth" [disabled]="!periodData.isEnabled"
                                      [ngModelOptions]="{standalone: true}" (change)="onSelectionChange(periodData)">
                                    </ng-select>
                                  </div>
                                </span>
                                <span class="period_labels and-ends">and ends</span>
                                <span class="endby_select">
                                  <div class="form-select-container border-lined"
                                    [ngClass]="{'error_field': formSubmitted && validationStates[i] && periodData.isEnabled}">
                                    <ng-select [items]="EndBy" class="cmn-ngselect" bindLabel="ends" bindValue="ends"
                                      [searchable]="false" [clearable]="false" [(ngModel)]="periodData.ends"
                                      data-testid="drpdwn-monthly-table-period-ends"
                                      [ngModelOptions]="{standalone: true}" [disabled]="!periodData.isEnabled"
                                      (change)="onSelectionChange(periodData)">
                                    </ng-select>
                                  </div>
                                </span>
                                <span class="startdate_picker" *ngIf="periodData.ends === 'On'">
                                  <div class="form-datepicker-container cmn-material-datepicker w-260"
                                    [ngClass]="{'error_field': formSubmitted && validationStates[i] && periodData.isEnabled}">
                                    <mat-form-field floatLabel="never" appearance="standard">
                                      <input class="cmn-mat-dtpicker-input" matInput
                                        [matDatepicker]="recurrancePeriodDatepicker" name="recurrancePeriodOn{{i}}"
                                        autocomplete="off" placeholder="dd/mm/yyyy" #recurrancePeriodOn="ngModel"
                                        data-testid="input-monthly-table-period-ends-on"
                                        [(ngModel)]="periodData.Period_on"
                                        (dateChange)="onRecurrancePeriodOnChange($event, i)" [min]="minDates[i]"
                                        [disabled]="!recurrenceEnableChk || isEditMode" required>
                                      <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix
                                        [for]="recurrancePeriodDatepicker"></mat-datepicker-toggle>
                                      <mat-datepicker panelClass="cmn-datepicker-ui"
                                        #recurrancePeriodDatepicker></mat-datepicker>
                                    </mat-form-field>
                                  </div>
                                </span>

                                <span class="endday_select" *ngIf="periodData.ends === 'After'">
                                  <div class="form-input-container border-lined"
                                    [ngClass]="{'error_field': formSubmitted && validationStates[i] && periodData.isEnabled}">
                                    <input type="text" class="form-control" [(ngModel)]="periodData.selctedEndDay"
                                    data-testid="input-monthly-table-period-ends-after"
                                      [disabled]="!periodData.isEnabled" [ngModelOptions]="{standalone: true}"
                                      (input)="validateInput($event, periodData, i)"
                                      (change)="onSelectionChange(periodData, i)" />
                                  </div>
                                </span>

                                <span class="period_labels" *ngIf="periodData.ends === 'After'">days</span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div *ngIf="!monthFlagCheck && recurranceData.Frequency === 'Monthly'"
                      class="no_period_message text-center">
                      <img src="../../../../assets/img/note_add.svg" width="225" height="225" />
                      <div class="bold_title">No Period</div>
                      <div class="sub_title">There are no period</div>
                    </div>
                    <!-- quarterly start-->
                    <div class="cmn-table-design periods_table_recurrence quarterly_table"
                      *ngIf="recurranceData.Frequency === 'Quarterly'">
                      <table *ngIf="qtrFlagCheck" class="table table-borderless mb-0"  data-testid="table-quarterly-table-period-start-end">
                        <colgroup>
                          <col width="13%" />
                          <col width="80%" />
                        </colgroup>
                        <tbody>
                          <tr *ngFor="let periodQuarterlyData of quarterDatas; let i = index">
                            <td [hidden]="!periodQuarterlyData.isEnabled"><span>{{ periodQuarterlyData.quarterly
                                }}</span></td>
                            <td [hidden]="!periodQuarterlyData.isEnabled" class="period_selection_column_row">
                              <div class="period_selection_column">
                                <span class="period_labels">Starts</span>
                                <span class="startdate_select">
                                  <div class="form-select-container border-lined"
                                    [ngClass]="{'error_field': formSubmitted && validationStates[i] && periodQuarterlyData.isEnabled}">
                                    <ng-select [items]="QuarterStartsDate" class="cmn-ngselect" bindLabel="QStartsweek"
                                      bindValue="QstartsId" [searchable]="false" [clearable]="false"
                                      [disabled]="!periodQuarterlyData.isEnabled"
                                      data-testid="drpdwn-quarterly-table-starts-date"
                                      [(ngModel)]="periodQuarterlyData.selctedQuarterStartsDate"
                                      [ngModelOptions]="{standalone: true}"
                                      (change)="onSelectionQtrChange(periodQuarterlyData)">
                                    </ng-select>
                                  </div>
                                </span>
                                <span class="startweek_select">
                                  <div class="form-select-container border-lined"
                                    [ngClass]="{'error_field': formSubmitted && validationStates[i] && periodQuarterlyData.isEnabled}">
                                    <ng-select [items]="QuarterStartsWeek" class="cmn-ngselect" bindLabel="QStartsday"
                                      bindValue="QStartsid" [searchable]="false" [clearable]="false"
                                      [disabled]="!periodQuarterlyData.isEnabled"
                                      data-testid="drpdwn-quarterly-table-starts-week"
                                      [(ngModel)]="periodQuarterlyData.selctedQuarterStartsDay"
                                      [ngModelOptions]="{standalone: true}"
                                      (change)="onSelectionQtrChange(periodQuarterlyData)">
                                    </ng-select>
                                  </div>
                                </span>
                                <span class="period_labels">of</span>
                                <span class="startmonth_select">
                                  <div class="form-select-container border-lined"
                                    [ngClass]="{'error_field': formSubmitted && validationStates[i] && periodQuarterlyData.isEnabled}">
                                    <ng-select [items]="StartsMonth" class="cmn-ngselect" bindLabel="StartMonth"
                                      bindValue="StartsMonthId" [searchable]="false" [clearable]="false"
                                      [(ngModel)]="periodQuarterlyData.selctedQuarterStartsMonth" data-testid="drpdwn-quarterly-table-starts-month"
                                      [ngModelOptions]="{standalone: true}" [disabled]="!periodQuarterlyData.isEnabled"
                                      (change)="onSelectionQtrChange(periodQuarterlyData)">
                                    </ng-select>
                                  </div>
                                </span>
                                <span class="period_labels and-ends">and ends</span>
                                <span class="endby_select">
                                  <div class="form-select-container border-lined"
                                    [ngClass]="{'error_field': validationStates[i] && periodQuarterlyData.isEnabled}">
                                    <ng-select [items]="QuarterEndBy" class="cmn-ngselect" bindLabel="quarterendsby"
                                      bindValue="quarterendsby" [searchable]="false" [clearable]="false" data-testid="drpdwn-quarterly-table-ends"
                                      [(ngModel)]="periodQuarterlyData.quarterendsby"
                                      [ngModelOptions]="{standalone: true}" [disabled]="!periodQuarterlyData.isEnabled"
                                      (change)="onSelectionQtrChange(periodQuarterlyData)">
                                    </ng-select>
                                  </div>
                                </span>
                                <span class="startdate_picker" *ngIf="periodQuarterlyData.quarterendsby === 'On'">
                                  <div class="form-datepicker-container cmn-material-datepicker w-260"
                                    [ngClass]="{'error_field': formSubmitted && validationStates[i] && periodQuarterlyData.isEnabled}">
                                    <mat-form-field floatLabel="never" appearance="standard">
                                      <input class="cmn-mat-dtpicker-input" matInput
                                        [matDatepicker]="recurrancePeriodDatepickerQuarter"
                                        name="recurrancePeriodOnQuarter{{i}}" autocomplete="off"
                                        placeholder="dd/mm/yyyy" [(ngModel)]="periodQuarterlyData.Period_QtrOn"
                                        [disabled]="!recurrenceEnableChk || isEditMode" required [min]="minDates[i]"
                                        (dateChange)="onRecurranceQuarterOnChange($event, i)">
                                      <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix
                                        [for]="recurrancePeriodDatepickerQuarter"></mat-datepicker-toggle>
                                      <mat-datepicker panelClass="cmn-datepicker-ui"
                                        #recurrancePeriodDatepickerQuarter></mat-datepicker>
                                    </mat-form-field>
                                  </div>
                                </span>

                                <span class="endday_select" *ngIf="periodQuarterlyData.quarterendsby === 'After'">
                                  <div class="form-input-container border-lined"
                                    [ngClass]="{'error_field': formSubmitted && validationStates[i] && periodQuarterlyData.isEnabled}">
                                    <input type="text" class="form-control"
                                      [(ngModel)]="periodQuarterlyData.selctedQuarterEndDay"
                                      [disabled]="!periodQuarterlyData.isEnabled" [ngModelOptions]="{standalone: true}"
                                      (input)="validateQuarterlyInput($event, periodQuarterlyData, i)"
                                      (change)="onSelectionQtrChange(periodQuarterlyData, i)" data-testid="input-quarterly-table-period-ends-after" />
                                  </div>
                                </span>

                                <span class="period_labels"
                                  *ngIf="periodQuarterlyData.quarterendsby === 'After'">days</span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div *ngIf="!qtrFlagCheck && recurranceData.Frequency === 'Quarterly'"
                      class="no_period_message text-center">
                      <img src="../../../../assets/img/note_add.svg" width="225" height="225" />
                      <div class="bold_title">No Period</div>
                      <div class="sub_title">There are no period</div>
                    </div>
                    <!-- quarterly end -->
                    <!-- annual start -->
                    <div class="cmn-table-design periods_table_recurrence quarterly_table"
                      *ngIf="recurranceData.Frequency === 'Annually'">
                      <table *ngIf="annualFlagCheck" class="table table-borderless mb-0" data-testid="table-annually-period-start-end">
                        <colgroup>
                          <col width="13%" />
                          <col width="80%" />
                        </colgroup>
                        <tbody>
                          <tr *ngFor="let periodData of annualDatas; let i = index">
                            <td [hidden]="!periodData.isEnabled"><span>{{ periodData.monthly }}</span></td>
                            <td class="period_selection_column_row" [hidden]="!periodData.isEnabled">
                              <div class="period_selection_column">
                                <span class="period_labels">Starts</span>
                                <span class="startdate_select">
                                  <div class="form-select-container border-lined"
                                    [ngClass]="{'error_field':formSubmitted &&  validationStates[i] && periodData.isEnabled}">
                                    <ng-select [items]="StartsDate" class="cmn-ngselect" bindLabel="startsWeek"
                                      bindValue="startsId" [searchable]="false" [clearable]="false"
                                      data-testid="drpdwn-annually-table-period-starts-date"
                                      [(ngModel)]="periodData.selctedStartsDate" [disabled]="!periodData.isEnabled"
                                      [ngModelOptions]="{standalone: true}" (change)="onSelectionChange(periodData)">
                                    </ng-select>
                                  </div>
                                </span>
                                <span class="startweek_select">
                                  <div class="form-select-container border-lined"
                                    [ngClass]="{'error_field': formSubmitted && validationStates[i] && periodData.isEnabled}">
                                    <ng-select [items]="StartsWeek" class="cmn-ngselect" bindLabel="StartsWeekDay"
                                      bindValue="WeekId" [searchable]="false" [clearable]="false"
                                      data-testid="drpdwn-annually-table-period-starts-week"
                                      [(ngModel)]="periodData.selctedStartsDay" [disabled]="!periodData.isEnabled"
                                      [ngModelOptions]="{standalone: true}" (change)="onSelectionChange(periodData)">
                                    </ng-select>
                                  </div>
                                </span>
                                <span class="period_labels">of</span>
                                <span class="startmonth_select">
                                  <div class="form-select-container border-lined"
                                    [ngClass]="{'error_field': formSubmitted && validationStates[i] && periodData.isEnabled}">
                                    <ng-select [items]="StartsMonth" class="cmn-ngselect" bindLabel="StartMonth"
                                      bindValue="StartsMonthId" [searchable]="false" [clearable]="false"
                                      data-testid="drpdwn-annually-table-period-starts-month"
                                      [(ngModel)]="periodData.selctedStartsMonth" [disabled]="!periodData.isEnabled"
                                      [ngModelOptions]="{standalone: true}" (change)="onSelectionChange(periodData)">
                                    </ng-select>
                                  </div>
                                </span>
                                <span class="period_labels and-ends">and ends</span>
                                <span class="endby_select">
                                  <div class="form-select-container border-lined"
                                    [ngClass]="{'error_field': formSubmitted && validationStates[i] && periodData.isEnabled}">
                                    <ng-select [items]="EndBy" class="cmn-ngselect" bindLabel="ends" bindValue="ends"
                                      [searchable]="false" [clearable]="false" [(ngModel)]="periodData.ends"
                                      data-testid="drpdwn-annually-table-period-ends"
                                      [ngModelOptions]="{standalone: true}" [disabled]="!periodData.isEnabled"
                                      (change)="onSelectionChange(periodData)">
                                    </ng-select>
                                  </div>
                                </span>
                                <span class="startdate_picker" *ngIf="periodData.ends === 'On'">
                                  <div class="form-datepicker-container cmn-material-datepicker w-260"
                                    [ngClass]="{'error_field': formSubmitted && validationStates[i] && periodData.isEnabled}">
                                    <mat-form-field floatLabel="never" appearance="standard">
                                      <input class="cmn-mat-dtpicker-input" matInput
                                       data-testid="input-annually-table-period-ends-on"
                                        [matDatepicker]="recurrancePeriodDatepicker" name="recurrancePeriodOn{{i}}"
                                        autocomplete="off" placeholder="dd/mm/yyyy" #recurrancePeriodOn="ngModel"
                                        [(ngModel)]="periodData.Period_on"
                                        (dateChange)="onRecurrancePeriodOnChange($event, i)" [min]="minDates[i]"
                                        [disabled]="!recurrenceEnableChk || isEditMode" required>
                                      <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix
                                        [for]="recurrancePeriodDatepicker"></mat-datepicker-toggle>
                                      <mat-datepicker panelClass="cmn-datepicker-ui"
                                        #recurrancePeriodDatepicker></mat-datepicker>
                                    </mat-form-field>
                                  </div>
                                </span>

                                <span class="endday_select" *ngIf="periodData.ends === 'After'">
                                  <div class="form-input-container border-lined"
                                    [ngClass]="{'error_field': formSubmitted && validationStates[i] && periodData.isEnabled}">
                                    <input type="text" class="form-control" [(ngModel)]="periodData.selctedEndDay"
                                      [disabled]="!periodData.isEnabled" [ngModelOptions]="{standalone: true}"
                                      data-testid="input-annually-table-period-ends-after" 
                                      (input)="validateInput($event, periodData, i)"
                                      (change)="onSelectionChange(periodData, i)" />
                                  </div>
                                </span>

                                <span class="period_labels" *ngIf="periodData.ends === 'After'">days</span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div *ngIf="!annualFlagCheck && recurranceData.Frequency === 'Annually'"
                      class="no_period_message text-center">
                      <img src="../../../../assets/img/note_add.svg" width="225" height="225" />
                      <div class="bold_title">No Period</div>
                      <div class="sub_title">There are no period</div>
                    </div>
                    <!-- annual end -->
                  </div>

                </div>
                <!-- right col end -->
              </div>
            </div>
            <!-- screen 3 recurrence end -->
          </div>
          <!-- stepper code parent div end-->
        </div>
          <div class="cmn-modal-footer">
            <button type="button" mat-button class="cmn-inverse-btn mr-auto" data-testid="btn-create-job-back" (click)="cerateJobBackScreen(-1)"
                    *ngIf="currentScreenActive >= 2">
              Previous
            </button>
            <div class="duplicate-error mr-3"
                 *ngIf="duplicateJobNames?.length > 0">
              A job with the same name and financial year already exists for this client. Please adjust the job name to proceed
            </div>
            <button type="button" mat-button class="cmn-blue-btn hover_action" data-testid="btn-create-job-next"
                    [disabled]="(clientJobForm.invalid || (duplicateJobNames.length > 0))" (click)="createJobScreenNext(1);"
                    *ngIf="currentScreenActive < lastTab">
              Next

            </button>


            <!-- <button type="submit" mat-button class="cmn-blue-btn" [disabled]="checkDisableButton" -->
            <button type="submit" mat-button class="cmn-blue-btn" data-testid="btn-create-job-submit" *ngIf="currentScreenActive === lastTab">
              {{
isEditMode ?
            'Update Job' : 'Create Job'
              }}
            </button>
            <button #cancelsaveJob class="cmn-inverse-btn" mat-button data-testid="btn-create-job-cancel" data-dismiss="modal"
                    (click)="isCancel = true; container.scrollTop = 0; clearclientlist();cleanJobform(clientJobForm);">
              Cancel
            </button>
            <!--<button type="button" #cancelsaveJob class="cmn-inverse-btn" mat-button data-dismiss="modal" (click)="container.scrollTop = 0;cleanJobform(clientJobForm);clearclientlist()">Cancel</button>-->
          </div>

      </div>
    </div>
  </div>
  </div>
  <!--  -->
</form>
<!--  -->


<ng-template #TaskEstimate let-task="task" let-group_index="group_index" let-task_index="task_index">
  <div class="edit-dropdwn-content">
    <h5 class="edit-dropdwn-content-title">Breakdown</h5>
    <div class="edit-dropdwn-content-list">
      <table class="breakdown-table-container" data-testid="table-breakdown-table">
        <tbody>
          <tr *ngFor="let estimate of task._estimateDataListUnsaved; let estimate_index = index">
            <td>
              <div class="form-select-filter-container createjobtask-temp-tbl-select bg-transparent">
                <ejs-dropdownlist name='roleSelect-{{group_index}}-{{task_index}}-{{estimate_index}}'
                  cssClass="cmn-filter-dropdown" [(ngModel)]="estimate.roleId" [dataSource]='estimate._availableRoles'
                  [allowFiltering]='false' placeholder='Select role' [fields]='ejsDropdownRoles'>
                </ejs-dropdownlist>
              </div>
            </td>
            <td>
              <div class="form-select-container select-assignee-dropdwn">
                <ng-select class="cmn-ngselect cmn-assign-staff-jobs users-ng-select"
                  name='taskUserSelect-{{group_index}}-{{task_index}}-{{estimate_index}}'
                  [items]="estimate._availableUsers" bindValue="userId" bindLabel="fullName"
                  (change)="onSelectTaskEstimateUser(estimate, task, $event)" [(ngModel)]="estimate.userId"
                  [clearable]="false" placeholder="Unassigned">
                </ng-select>
              </div>
            </td>
            <td *ngIf="jobDataModal.jobEstimateType === 'Task'">
              <div class="units-inpt-controll">
                <input type="number" min="0" class="form-control"
                  name='estimateUnits-{{group_index}}-{{task_index}}-{{estimate_index}}' (keypress)="numberOnly($event)"
                  [(ngModel)]="estimate.unit" (blur)="onEstimateUnitBlur(estimate, task)" />
                units
              </div>
            </td>
            <td>
              <button *ngIf="task._estimateDataListUnsaved.length > 1" type="button" class="drpdwn-delete-row-btn"
                (click)="deleteTaskEstimation(task, estimate_index)" data-testid="btn-breakdown-delete-row">
                <img src="../../../../assets/img/close-gray.svg" alt="icon">
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="edit-dropdwn-content-addrow-btn">
        <button type="button" class="addnewrow-btn" (click)="addTaskEstimation(task)" data-testid="btn-breakdown-add-row">
          +Add row
        </button>
      </div>
    </div>
    <div class="edit-dropdwn-content-footer">
      <button type="button" mat-button class="cmn-blue-btn" (click)="saveBreakdownPopup(task)" [disabled]="isBreakdownSaveDisabled(task)" data-testid="btn-breakdown-save">Save</button>
      <button type="button" class="cmn-inverse-btn" mat-button (click)="closeBreakdownPopup(task)" data-testid="btn-breakdown-cancel" data-testid="btn-breakdown-cancel">Cancel</button>
    </div>
  </div>
</ng-template>
